import React from 'react'
// libs
import styled from 'styled-components'
// constants
import { Modals } from 'constants/modals'
// hooks
import { useShowModal } from 'hooks'
// components
import { IconButton } from 'components/UI'
// icons
import ScheduleReviewIconOrigin from 'src/icons/schedule-review.svg'
// utils
import { size } from 'polished'
// context
import { PlanEditPageContext } from 'containers/Plan/Edit/layers/API'

const ScheduleReviewIcon = styled(ScheduleReviewIconOrigin)`
  && {
    ${size('25px')};

    path {
      fill: white;
    }
  }
`

const PlanScheduleSettings: React.FC = () => {
  const { plan } = React.useContext(PlanEditPageContext)

  const { showModal } = useShowModal({ modalType: Modals.PLAN_SCHEDULE_DEFAULTS_MODAL })

  const showScheduleDefaultsModal = () => showModal({ plan })

  return (
    <IconButton onClick={showScheduleDefaultsModal} description='Schedule Default Settings'>
      <ScheduleReviewIcon />
    </IconButton>
  )
}

export default PlanScheduleSettings
